<script src="./mvt-newmap.js">
</script>
<template>
    <GoogleMap
        class="mvt-newmap"
        ref="mapRef"
        mapId="MOVOTO_CUSTOM_MAP"
        :apiPromise="apiPromise"
        :mapTypeId="mapType"
        :zoom="zoom"
        :clickableIcons="false"
        :gestureHandling="gestureHandling"
        :zoomControl="zoomControl"
        disableDefaultUi
        scrollwheel
        zoomable
        :draggable="draggable"
        @dragstart="onDragStart"
        @dragend="onDragEnd"
        @zoom_changed="onZoomChanged"
        @center_changed="onCenterChanged"
        @idle="onIdle"
    >
        <template #default="{ ready, api, map, mapTilesLoaded }">
            <div v-if="!mapTilesLoaded" class="mvt-newmap-loading"><div class="spinner"></div></div>
            <!-- Listings -->
            <mvtPropertyMarker
                v-if="!freeDrawEnabled && ready"
                v-for="(marker, i) in listingMarkers"
                :key="marker.key"
                :position="marker.position"
                :properties="marker.data"
                :isHomePin="marker.isHomePin"
                :disablePopup="disableMarkerPopups"
                :map="map"
                @markerSelected="onMarkerSelected"
                @markerUnselect="onMarkerUnselect"
                :data-key="marker.key"
                :autoSelect="marker.autoSelect"
            />
            <!-- POIs -->
            <mvtPoiMarker
                v-if="!freeDrawEnabled && ready"
                v-for="(marker, i) in poiMarkers"
                :key="marker.key"
                :position="marker.position"
                :poi="marker.data"
                :disablePopup="disableMarkerPopups"
                @markerSelected="onMarkerSelected"
                @markerUnselect="onMarkerUnselect"
                :data-key="marker.key"
                :autoSelect="marker.autoSelect"
            />
            <!-- Schools -->
            <mvtSchoolMarker
                v-if="!freeDrawEnabled && ready"
                v-for="(marker, i) in schoolMarkers"
                :key="marker.key"
                :position="marker.position"
                :school="marker.data"
                :disablePopup="disableMarkerPopups"
                @markerSelected="onMarkerSelected"
                @markerUnselect="onMarkerUnselect"
                :data-key="marker.key"
                :autoSelect="marker.autoSelect"
            />
            <!-- Boundary Active & Boundary Considered -->
            <Polygon v-if="hasActiveBoundary && ready" :options="{ ...boundaryPolygonStyle[boundaryTheme], paths: boundaryPolygon }" />
            <!-- Boundary Active & Boundary Ignored -->
            <Polyline v-if="hasInactiveBoundary && ready" v-for="(boundaryPolyline, i) in boundaryPolylines" :options="{ ...boundaryPolylineStyle, path: boundaryPolyline }" />
            <!-- Rectangle draw preview -->
            <Polygon v-if="freeDrawEnabled && previewDrawnPath.length && ready" :options="{ ...drawPreviewStyle, paths: [previewDrawnPath] }" />
            <!-- Drawn Polygon -->
            <Polygon v-if="hasActiveDrawing && ready" :options="{ ...boundaryPolygonStyle[boundaryTheme], paths: drawnPolygon }" />
            <!-- Slot -->
            <slot
                v-if="ready"
                v-bind="{
                    showBoundary,
                    enableDrawing,
                    changeMapLayer,
                    changeMapType,
                    clearDrawing,
                    setStreetView,
                    listingMarkers,
                    poiMarkers,
                    schoolMarkers,
                    activeLayer,
                    activeMapType,
                    freeDrawEnabled,
                    hasActiveDrawing,
                    hasActiveBoundary,
                    hasActiveStreetView,
                    isBoundsInMapView,
                }"
            />
        </template>
    </GoogleMap>
</template>

<style lang="scss">
.mvt-newmap {
    .gm-style iframe + div {
        border: none !important;
    }
    position: relative;
}

.pin-poi{
    z-index: 10;
}
.pin-school{
    z-index: 49;
}

.pin-house{
    z-index: 40;
    &.mini{
        z-index: 30;
    }
    &.sold{
        z-index: 39;
    }
    &.new, &.hot{
        z-index: 41;
    }
    &.viewed {
        z-index: 42;
    }
    &.favorite {
        z-index: 43;
    }
    &.home{
        z-index: 50;
    }

}

.pin-hover {
    z-index: 99 !important;
}
.pin-selected {
    z-index: 100 !important;
}
.pin-hover, .pin-selected  {
    .mvt-poimarker .mvt-poimarker__dot,
    .mvt-schoolmarker .mvt-schoolmarker__dot {
        transform: scale(1.5);
        cursor: pointer;
        background-color: var(--map-marker-color-bg-hover);
    }
    .mvt-propertymarker {
        .mvt-propertymarker__dot,
        .mvt-propertymarker__price {
            color: var(--map-marker-color-hover);
            background-color: var(--map-marker-color-bg-hover);
            box-shadow: 0 0 0 1px var(--map-marker-color-border-hover), var(--map-marker-box-shadow);
            transform: scale(1.5);
        }

        .mvt-propertymarker__pin {
            color: var(--map-marker-color-bg-hover);
            transform: scale(1.5);
        }
    }
}

</style>